import Collapsible from '../Collapsible/Collapsible';

import styles from '../../css/Projects.module.css';

const Projects = () => (
  <main className="mainContainer">
    <div className={styles.contentContainer} style={{ paddingTop: "3rem" }}>
      <h1>PROJECTS</h1>

      <section className={styles.projectsContainer}>
        <div className={styles.projectCard}>
          <h2 className={styles.projectName}>ENCORE ME</h2>
          <p className={styles.projectBodyText}>A platform for performers and musicians to engage audiences in real-time through interactive setlists. Passers-by or audience members can scan a QR code to browse and request songs.</p>

          <Collapsible>
            <div className={styles.projectInfo}>
              <ul className={styles.projectBulletPoints}>
                <li>Created a platform enabling musicians to build curated setlists with auto-generated QR codes for sharing.</li>
                <li>Designed a real-time song request system allowing audience members to browse repertoire and submit requests during live performances.</li>
                <li>Implemented JWT authentication and validation with Joi for a robust API.</li>
                <li>Tech: Next.js, React 19, TypeScript, TailwindCSS, Neon Postgres.</li>
              </ul>
            </div>
          </Collapsible>
        </div>

        <div className={styles.projectCard}>
          <a className={styles.clickable} href="https://apps.apple.com/us/app/perfect-rhythms/id6744438772" rel="noopener noreferrer" target="_blank" aria-label="Perfect Pulse (opens in new tab)"><h2 className={styles.projectName}>PERFECT PULSE</h2></a>
          <p className={styles.projectBodyText}>An iOS game that trains players to accurately recognize and assign tempo or BPM (beats per minute) values to rhythmic patterns. Made for iPhone and iPad.</p>

          <Collapsible>
            <div className={styles.projectInfo}>
              <ul className={styles.projectBulletPoints}>
                <li>Designed a progressive challenge system that tracks consecutive correct guesses and personal records to encourage skill-building & player improvement.</li>
                <li>Used low latency audio processing techniques to generate rhythmic patterns with perfect precision.</li>
                <li>Tech: Swift, SwiftUI, Xcode.</li>
              </ul>
            </div>
          </Collapsible>
        </div>

        <div className={styles.projectCard}>
          <a className={styles.clickable} href="https://apple.co/4d8puoU" rel="noopener noreferrer" target="_blank"><h2 className={styles.projectName}>PRACTICE CAPSULE</h2></a>
          <p className={styles.projectBodyText}>An app built with React-Native for musicians to document their progress over time. Video clips that they record are automatically delivered to them weeks, months, or years later.</p>

          <Collapsible>
            <div className={styles.projectInfo}>
              <ul className={styles.projectBulletPoints}>
                <li>Designed to encourage long-term growth and reflection.</li>
                <li>Built with React Native and Expo for cross-platform compatibility.</li>
                <li>Integrates the SendGrid Email API to send scheduled emails to users&apos; future selves or collaborators.</li>
                <li>Tech: React Native, Expo, Firebase, Sendgrid Email API.</li>
              </ul>
            </div>
          </Collapsible>
        </div>

        <div className={styles.projectCard}>
          <a className={styles.clickable} href="https://musicinvaders.com/" rel="noopener noreferrer" target="_blank" aria-label="Music Invaders (opens in new tab)"><h2 className={styles.projectName}>MUSIC INVADERS</h2></a>
          <p className={styles.projectBodyText}>An arcade-style music game that sharpens musicians&apos; note and chord recognition skills. Players use a MIDI instrument to defeat incoming waves of enemies in real-time.</p>

          <Collapsible>
            <div className={styles.projectInfo}>
              <ul className={styles.projectBulletPoints}>
                <li>Designed and developed an interactive browser game that takes precise musical input from a MIDI controller.</li>
                <li>Integrated responsive UI and audio feedback to create an immersive, skill-based music gaming experience on computers and tablets.</li>
                <li>Tech: JavaScript, Web MIDI API, HTML5 Canvas.</li>
              </ul>
            </div>
          </Collapsible>
        </div>

        <div className={styles.projectCard}>
          <a className={styles.clickable} href="https://code-with-the-pros.vercel.app/intro" rel="noopener noreferrer" target="_blank" aria-label="Code With The Pros (opens in new tab)"><h2 className={styles.projectName}>CODE WITH THE PROS</h2></a>
          <p className={styles.projectBodyText}>An interactive online textbook that teaches computer science and coding topics, complete with reading, integrated exercises, and applicable projects.</p>

          <Collapsible>
            <div className={styles.projectInfo}>
              <ul className={styles.projectBulletPoints}>
                <li>Developed an interactive online textbook that teaches computer science and programming concepts through engaging, real-world projects and exercises.</li>
                <li>Designed lesson content to balance theoretical understanding with hands-on coding practice, making complex topics accessible and relatable.</li>
                <li>Built interactive reading experiences to enhance learner engagement and retention.</li>
                <li>Focused on creating a supportive, self-paced learning environment for beginners and intermediate coders.</li>
                <li>Tech: React, Node.js, Supabase.</li>
              </ul>
            </div>
          </Collapsible>
        </div>
      </section>
    </div>
  </main>
)

export default Projects;
